import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import invariant from 'fbjs/lib/invariant';
import requestIdleCallback, { cancelIdleCallback } from "../../modules/requestIdleCallback";
var InteractionManager = {
  Events: {
    interactionStart: 'interactionStart',
    interactionComplete: 'interactionComplete'
  },
  runAfterInteractions: function runAfterInteractions(task) {
    var handle;
    var promise = new Promise(function (resolve) {
      handle = requestIdleCallback(function () {
        if (task) {
          resolve(task());
        } else {
          resolve();
        }
      });
    });
    return {
      then: promise.then.bind(promise),
      done: promise.then.bind(promise),
      cancel: function cancel() {
        cancelIdleCallback(handle);
      }
    };
  },
  createInteractionHandle: function createInteractionHandle() {
    return 1;
  },
  clearInteractionHandle: function clearInteractionHandle(handle) {
    invariant(!!handle, 'Must provide a handle to clear.');
  },
  addListener: function addListener() {}
};
export default InteractionManager;